import {
  BottomNavigation,
  BottomNavigationAction,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { Trans, useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer>
      <BottomNavigation
        showLabels
        sx={{ fontSize: "1.5rem", backgroundColor: "inherit" }}
      >
        <BottomNavigationAction
          sx={{
            ".MuiBottomNavigationAction-label": {
              fontSize: "1rem",
              padding: 1,
            },
          }}
          label="Helpdesk"
          href="https://pohde.zendesk.com/hc/fi-fi"
          icon={<HelpIcon fontSize="large" />}
        />
      </BottomNavigation>
      <Stack alignItems="center" spacing={1} padding={1}>
        <Typography variant="body2" color="textSecondary">
          <Trans i18nKey="footer.faq" t={t}>
            <Link href="https://pohde.zendesk.com/hc/fi-fi">FAQ</Link>.
          </Trans>
        </Typography>
      </Stack>
    </footer>
  );
}
